export default "__VITE_ASSET__DrOeAqz5__"